package com.klantenstop.web.pages.admin.curatedcities.manage

import com.klantenstop.web.data.models.domain.CuratedCity
import com.klantenstop.web.data.models.domain.Province
import com.klantenstop.web.utils.MVI

interface ManageCuratedCityContract : MVI<ManageCuratedCityContract.State, ManageCuratedCityContract.Intent, ManageCuratedCityContract.Effect> {

    enum class GeocodeState {
        Success,
        Error
    }

    data class State(
        val curatedCity: CuratedCity? = null,
        val isLoading: Boolean = false,
        val isSaving: Boolean = false,
        val isGeocoding: Boolean = false,
        val geocodeState: GeocodeState? = null,
        val name: String = "",
        val province: Province? = null,
        val latitude: String = "",
        val longitude: String = "",
        val isFeatured: Boolean = false,
    ) {
        private val nameIsValid = name.isNotBlank()
        private val provinceIsValid = province != null
        private val latitudeIsValid = latitude.toDoubleOrNull()?.let { it in -90.0..90.0 } ?: false
        private val longitudeIsValid = longitude.toDoubleOrNull()?.let { it in -180.0..180.0 } ?: false

        private val nameChanged = name != (curatedCity?.name ?: "")
        private val provinceChanged = province != curatedCity?.province
        private val latitudeChanged = latitude != (curatedCity?.latitude?.toString() ?: "")
        private val longitudeChanged = longitude != (curatedCity?.longitude?.toString() ?: "")
        private val isFeaturedChanged = isFeatured != (curatedCity?.isFeatured ?: false)

        val isValid = nameIsValid && provinceIsValid && latitudeIsValid && longitudeIsValid

        val hasChanged: Boolean
            get() = nameChanged || provinceChanged || latitudeChanged || longitudeChanged || isFeaturedChanged
    }

    sealed class Intent {
        data object NavigateBack : Intent()
        data class LoadCuratedCity(val curatedCityId: String) : Intent()
        data class UpdateName(val name: String) : Intent()
        data class UpdateProvince(val province: Province) : Intent()
        data class UpdateLatitude(val latitude: String) : Intent()
        data class UpdateLongitude(val longitude: String) : Intent()
        data class UpdateIsFeatured(val isFeatured: Boolean) : Intent()
        data object GeocodeCity : Intent()
        data object SaveCuratedCity : Intent()
    }

    sealed class Effect {
        data object NavigateBack : Effect()
        data class ShowError(val message: String) : Effect()
        data class ShowSuccess(val message: String) : Effect()
    }
}
